import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-835785f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-3" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "External Systems")
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 mb-3" }
const _hoisted_5 = { class: "table table-systems" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "System"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25" }),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Added"),
    /*#__PURE__*/_createElementVNode("th", null, "Expire"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} })
  ])
], -1))
const _hoisted_7 = { class: "system-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "info"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-sync fa-fw" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash fa-fw" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("form", null, null, -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 mb-3" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus fa-fw" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalSystems, (system, systemIdx) => {
              return (_openBlock(), _createElementBlock("tr", { key: systemIdx }, [
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.externalSystemTypes[system.type].icon,
                    class: "system-icon"
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.externalSystemTypes[system.type].label), 1),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(system.name) + " ", 1),
                  (system.info)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.info, (info, infoIdx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: infoIdx }, [
                              _createElementVNode("th", null, _toDisplayString(info.name) + ":", 1),
                              _createElementVNode("td", null, _toDisplayString(info.value), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(system.created_at), 1),
                _createElementVNode("td", null, _toDisplayString(system.expire_at), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-info",
                    onClick: ($event: any) => (_ctx.reauthSystem(system.id))
                  }, _hoisted_12, 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    onClick: ($event: any) => (_ctx.deleteSystem(system.id))
                  }, _hoisted_15, 8, _hoisted_13)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalSystemTypes, (type, typeIdx) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: typeIdx,
            to: type.addRoute,
            class: "btn btn-darklight w-auto btn-external-system"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: type.icon
              }, null, 8, _hoisted_19),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createTextVNode(" Add " + _toDisplayString(type.label), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}